import { Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Practice from './pages/Practice';
import QuestionBank from './pages/QuestionBank';
import Stats from './pages/Stats';
import useQuestionStore from './stores/questionStore';

export default function App() {
  const loadQuestions = useQuestionStore((s) => s.loadQuestionsFromJSON);

  useEffect(() => {
    loadQuestions();
  }, []);

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/practice" element={<Practice />} />
        <Route path="/questions" element={<QuestionBank />} />
        <Route path="/stats" element={<Stats />} />
      </Route>
    </Routes>
  );
}
